import commonFunction from '@/commons/commonFunction';
import {useToast} from 'vue-toast-notification';
import EventBusGlobal from '@/commons/eventBusGlobal';

export const useWebSocketFactoryNotificationStore = () => {

  /**
   * Convert data để tạo tham số gọi hàm postedMultiError
   * @param {*} dataError
   * @returns
   */
  const convertData = dataError => {
    if (dataError && dataError.data) {
      const res = [];
      const master = JSON.parse(dataError.data);
      if (master.number_success == 0) {
        var toastProps  ={
          position: 'top',
        }
        const $toast = useToast();
        $toast.success('Khóa sổ thành công', toastProps);
        EventBusGlobal.$emit('MsBottomRightProgressFinish');
      }
      if (master.log_data) {
        master.log_data.filter(function (item) {
          const record = JSON.parse(item);
          res.push({
            DataBusinessException: {
              Code: record.description,
              Data: [
                {
                  account_number: '',
                  ref_date: record.posted_date,
                  ref_id: record.refid,
                  ref_no: record.refno,
                  ref_type: record.reftype,
                },
              ],
              Type: '',
            },
          });
        });
      }
      // this.$toast.success('Khoá sổ thành công');
      if (res.length > 0) {
        commonFunction.postedMultiError(res, {}, 1);
      }
    }
  };



  return {
    convertData,
  };
};
